import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/device_models?include=homologations`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/device_models/${id}?include=firmwareVersions`, options)
        .then(response => {
            let deviceModel = jsona.deserialize(response.data);
            delete deviceModel.links;
            return deviceModel;
        });
}

function add(deviceModel) {
    const payload = jsona.serialize({
        stuff: deviceModel,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device_models`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(deviceModel) {
    const payload = jsona.serialize({
        stuff: deviceModel,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/device_models/${deviceModel.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/device_models/${id}`, options);
}

function checkByUniqueNumber(uniqueNumber) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/device-models/check-by-unique-number/${uniqueNumber}?include=firmwareVersions`, options)
        .then(response => {
            let deviceModel = jsona.deserialize(response.data);
            delete deviceModel.links;
            return deviceModel;
        });
}

export default {
    list,
    get,
    add,
    update,
    destroy,
    checkByUniqueNumber
};